import React from 'react';
import { Outlet } from 'react-router-dom';

import LangSwitcher from '@/uikit/LangSwitcher/LangSwitcher';
import ThemeSwitcher from '@/uikit/ThemeSwitcher/ThemeSwitcher';

import styles from './styles.module.scss';

const Root = () => (
  <div className={styles.root}>
    <span className={styles.switcher}>
      <LangSwitcher />
      <ThemeSwitcher />
    </span>
    <Outlet />
  </div>
);

export default Root;
